module.exports = __webpack_public_path__ + "img/traffic-junction-6.357f7127.jpg";